export const DEFAULT_CONFIRM_LABEL = "Got it";

/** Spacing steps, between the check glyph and the title. */
export const TITLE_ICON_GAP = 0.5;

/** The glyph's box, in px — Figma's `Icon / check`. */
export const TITLE_ICON_SIZE = 16;
